// Veelgestelde vragen en ZAV (components/faqTopics.cshtml) en de vragen in de zoekresultaten (Zoeken.cshtml).
// Per .js-faq: onderwerpen (.js-faq--topic) wisselen het zichtbare onderwerp (article); vragen (.js-item) klappen open
// via de vraag (dt). Er staat steeds één vraag open: de eerste van het eerste onderwerp bij het laden.
class Faq {
    private items: HTMLElement[];

    constructor(private root: HTMLElement) {
        const topics = Array.from(root.querySelectorAll<HTMLAnchorElement>('.js-faq--topic'));
        const articles = Array.from(root.querySelectorAll<HTMLElement>('article'));
        this.items = Array.from(root.querySelectorAll<HTMLElement>('.js-item'));

        // Onderwerpkoppen in de artikelen zijn alleen voor schermlezers; de onderwerpenlijst staat ernaast
        for (const heading of Array.from(root.querySelectorAll<HTMLElement>('.js-accessibility'))) {
            heading.style.display = 'none';
        }

        for (const item of this.items) {
            item.classList.remove('active');
            const question = item.querySelector<HTMLElement>('dt');
            if (!question) { continue; }
            question.setAttribute('role', 'button');
            question.setAttribute('tabindex', '0');
            question.addEventListener('click', () => this.toggle(item));
            question.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    this.toggle(item);
                }
            });
        }

        for (const topic of topics) {
            topic.addEventListener('click', (event) => {
                event.preventDefault();
                const target = root.querySelector<HTMLElement>('#' + topic.getAttribute('aria-controls'));
                for (const article of articles) { article.style.display = article === target ? '' : 'none'; }
                const wasActive = topic.classList.contains('active');
                for (const t of topics) { t.classList.remove('active'); t.setAttribute('aria-expanded', 'false'); }
                if (!wasActive) {
                    topic.classList.add('active');
                    topic.setAttribute('aria-expanded', 'true');
                }
            });
        }

        // Begintoestand: eerste onderwerp zichtbaar en actief, met de eerste vraag open
        articles.forEach((article, i) => { article.style.display = i === 0 ? '' : 'none'; });
        if (topics.length) {
            topics[0].classList.add('active');
            topics[0].setAttribute('aria-expanded', 'true');
        }
        const firstItem = articles.length ? articles[0].querySelector<HTMLElement>('.js-item') : null;
        if (firstItem) { this.toggle(firstItem); }
    }

    private toggle(item: HTMLElement) {
        const open = !item.classList.contains('active');
        for (const other of this.items) {
            other.classList.remove('active');
            this.setExpanded(other, false);
        }
        if (open) {
            item.classList.add('active');
            this.setExpanded(item, true);
        }
    }

    private setExpanded(item: HTMLElement, expanded: boolean) {
        const question = item.querySelector('dt');
        if (question) { question.setAttribute('aria-expanded', String(expanded)); }
    }
}

for (const root of Array.from(document.querySelectorAll<HTMLElement>('.js-faq'))) {
    new Faq(root);
}

export {};
